// Get values without keys from an enum, doesn't allow for numeric values
export const getEnumValues = (enumObject: any) => Object.keys(enumObject).filter(k => isNaN(Number(k)))
